// extracted by mini-css-extract-plugin
export var infoItem = "_qa-2";
export var title = "_qa-0";
export var value = "_qa-1";